// FrameRoutes.ts
const FrameRoutes = [
  {
    path: '/frames/my',
    name: 'MyFrames',
    component: () => import('@/views/frames/MyFrames.vue'),
    meta: {
      requiresAuth: true,
      title: 'My Frames',
    },
  },
  {
    path: '/frames/cambodia',
    name: 'One Cambodia Frame',
    component: () => import('@/views/frames/OneCambodiaFrame.vue'),
    meta: {
      requiresAuth: false,
      title: 'One Cambodia Frame',
    },
  },
]

export default FrameRoutes
